<template>
  <div>
    <v-form v-if="user.can_change_password"
            @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title>
          Change Password
        </v-card-title>
        <v-card-text class="pb-1">
          <v-text-field v-model="form.current_password"
                        label="Current Password"
                        outlined
                        placeholder="Enter your current password"
                        type="password"
                        autocomplete="new-password"
                        required
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('current_password')">
          </v-text-field>

          <v-text-field v-model="form.password"
                        label="New Password"
                        outlined
                        :hide-details="!form.errors.has('password')"
                        :placeholder="`Enter a new password (at least ${this.minPasswordLength} characters).`"
                        :type="showPassword ? 'text' : 'password'"
                        autocomplete="new-password"
                        counter
                        required
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('password')">
            <template v-slot:append>
              <v-chip :color="form.password.length < minPasswordLength ? 'error' : 'success'"
                      label
                      small>
                {{ form.password.length }}
              </v-chip>
              <v-icon @click="showPassword = !showPassword"
                      right>
                fal {{ showPassword ? 'fa-eye-slash' : 'fa-eye' }}
              </v-icon>
            </template>
          </v-text-field>
          <password v-model="form.password"
                    :secure-length="minPasswordLength"
                    strength-meter-only>
          </password>

          <v-text-field v-model="form.password_confirmation"
                        label="Confirm New Password"
                        outlined
                        placeholder="Retype new password"
                        type="password"
                        autocomplete="off"
                        required
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('password_confirmation')">
            <template v-slot:append>
              <v-icon :color="passwordsMatch ? 'success' : 'warning'">
                fal {{ passwordsMatch ? 'fa-check-circle' : 'fa-exclamation-triangle' }}
              </v-icon>
            </template>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 block
                 :disabled="form.busy || !formValid">
            Change Password
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-card v-else>
      <v-card-text>
        Your company's security policy does not allow you to change your password.
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../../plugins/formValidation';
import Password from 'vue-password-strength-meter';
import passwordPolicyService from '../../../../../ml/services/passwordPolicyService';

export default {
  mixins: [formValidation],
  components: {Password},
  metaInfo() {
    this.$store.commit('setTitle', 'Change Password');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      form: new Form({
        current_password: '',
        password: '',
        password_confirmation: '',
      }),
      showPassword: false,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    minPasswordLength() {
      return this.team.password_min_characters
        ? this.team.password_min_characters
        : passwordPolicyService.getMinPasswordLength();
    },
    passwordsMatch() {
      return this.form.password &&
        this.form.password === this.form.password_confirmation;
    },
    formValid() {
      return this.form.current_password
        && this.passwordsMatch;
    }
  },
  methods: {
    async submit() {
      if (this.form.busy) {
        return;
      }
      try {
        await this.form.put(`/api/user/password`)
        this.$store.commit('setSuccessMessage', 'Your password was changed successfully.');
        this.$router.push({name: 'show_profile'});
      } catch (err) {
        this.$store.commit('setErrorMessage', 'There was a problem changing your password.');
      }
    }
  }
}
</script>
